import {gql} from '@apollo/client';
import {PenaltySource} from '../../../penaltyCenter/graphql/types';

/**
 * 罚单申诉审核列表（分页 + 筛选）+ 按状态计数
 *
 * 与 api-server `PartnerControlAppealReviewQuery.getAppealTicketPageList` / `getAppealTicketCount` 对应。
 * 数据源为 swiftx-base-data-service 的 partner_penalty 表；非主键字段按可空处理。
 */

export enum AppealTicketStatus {
    PENDING = 'PENDING',
    WAITING = 'WAITING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    TIMEOUT = 'TIMEOUT',
    PENDING_SUBMIT = 'PENDING_SUBMIT',
    /** 已放弃：DSP 放弃申诉（申诉认罚） */
    ACCEPTED = 'ACCEPTED',
}

export interface AppealTicketType {
    id: number;
    ticketNo: string;
    trackingNumber?: string | null;
    dspName?: string | null;
    reason?: string | null;
    amount?: number | null;
    appealReason?: string | null;
    /** ISO-8601 字符串；尚无申诉记录时为空 */
    appealTime?: string | null;
    status: AppealTicketStatus;
}

export interface AppealTicketFiltersTypeInput {
    hubId?: string;
    warehouseId?: string;
    dspId?: number;
    trackingNumbers?: string[];
    status?: AppealTicketStatus;
    /** 罚单生成时间范围，ISO-8601，起止均含 */
    creationTimeRange?: {start: string; end: string};
    /** 罚款原因类型（罚单来源）多选 */
    penaltySources?: PenaltySource[];
}

export const GET_APPEAL_TICKET_PAGE_LIST = gql`
    query GetAppealTicketPageList($filters: AppealTicketFiltersTypeInput, $page: Int! = 1, $size: Int! = 20) {
        getAppealTicketPageList(filters: $filters, page: $page, size: $size) {
            content {
                id
                ticketNo
                trackingNumber
                dspName
                reason
                amount
                appealReason
                appealTime
                status
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface GetAppealTicketPageListResponse {
    getAppealTicketPageList: {
        content: AppealTicketType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export const GET_APPEAL_TICKET_COUNT = gql`
    query GetAppealTicketCount($filters: AppealTicketFiltersTypeInput) {
        getAppealTicketCount(filters: $filters)
    }
`;

export interface GetAppealTicketCountResponse {
    getAppealTicketCount: number;
}
